import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=b3ab6c3c&scoped=true&lang=pug&"
import script from "./ModuleSettings.vue?vue&type=script&lang=js&"
export * from "./ModuleSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=b3ab6c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ab6c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
